import axios from "axios";
import { Base_Url } from "./Constant/ApiRoutes";
import { showMessage, logout } from "./utils";
import { getState } from "./Constant/LocalStorage";

const axiosInstance = axios.create({
  credentials: "include",
  withCredentials: true,
  baseURL: Base_Url,
});

axiosInstance.interceptors.request.use(
  function (config) {
    const adminDetails = getState("adminDetails");
    if (adminDetails?.usergroupNameSlug) {
      config.baseURL = Base_Url + adminDetails?.usergroupNameSlug + "/";
    }
    const token = getState("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data && response.data.status === 200) {
      if (response.data.message) showMessage(response.data.message);
      return Promise.reject(response.data);
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.data) {
      if (error.response.status === 401) {
        localStorage.clear();
      }
      if (error.response.data.message) showMessage(error.response.data.message);
    } else if (error?.message) {
      showMessage(error.message);
      return Promise.reject(error);
    }
    return Promise.reject(error.response);
  }
);

export const getRequest = (url, payload) => {
  let config = {
    params: {
      ...payload,
    },
  };
  return axiosInstance.get(url, config);
};

export const postRequest = (url, payload, params) => {
  return axiosInstance.post(url, payload, { params: params });
};

export const putRequest = (url, payload, params) => {
  return axiosInstance.put(url, payload, { params: params });
};

export const deleteRequest = (url, bodyPayload, urlPayload) => {
  let config = {
    params: {
      ...urlPayload,
    },
    data: Array.isArray(bodyPayload) ? [...bodyPayload] : { ...bodyPayload },
  };
  return axiosInstance.delete(url, config);
};
